import { useEffect, useRef } from "react";
import { hideLegacyPreloader } from "./hideLegacyPreloader";

const scriptList = [
  "/questions.js",
  "/main.js",
  "/js/jquery-3.5.1.min.js",
  "/js/jquery-migrate-3.0.0.min.js",
  "/js/modernizr-2.6.2.min.js",
  "/js/imagesloaded.pkgd.min.js",
  "/js/jquery.isotope.v3.0.2.js",
  "/js/pace.js",
  "/js/popper.min.js",
  "/js/bootstrap.min.js",
  "/js/scrollIt.min.js",
  "/js/jquery.waypoints.min.js",
  "/js/owl.carousel.min.js",
  "/js/jquery.stellar.min.js",
  "/js/jquery.magnific-popup.js",
  "/js/YouTubePopUp.js",
  "/js/before-after.js",
  "/js/custom.js",
];

let legacyLoaded = false;
const customSrc = "/js/custom.js";
const initialScripts = scriptList.filter((s) => s !== customSrc);

function loadScript(src, { bust = false } = {}) {
  return new Promise((resolve, reject) => {
    const el = document.createElement("script");
    el.src = bust ? `${src}?v=${Date.now()}` : src;
    el.async = false;
    el.onload = () => resolve(true);
    el.onerror = () => reject(new Error(`Failed to load ${src}`));
    document.body.appendChild(el);
  });
}

export default function useLegacyHomeScripts() {
  const loadedRef = useRef(false);

  useEffect(() => {
    if (loadedRef.current) return;
    loadedRef.current = true;

    const fallback = window.setTimeout(hideLegacyPreloader, 2000);

    (async () => {
      try {
        // Load vendor scripts only once per SPA session.
        if (!legacyLoaded) {
          for (const src of initialScripts) {
            try {
              // eslint-disable-next-line no-await-in-loop
              await loadScript(src);
            } catch (scriptErr) {
              // eslint-disable-next-line no-console
              console.warn("[legacy-home] failed to load", src, scriptErr);
            }
          }
          legacyLoaded = true;
        }

        // Always re-run custom.js so it binds to the newly-mounted Home DOM.
        await loadScript(customSrc, { bust: true });
      } catch (e) {
        // Home scripts are best-effort during migration.
        // eslint-disable-next-line no-console
        console.warn("[legacy-home] script load issue:", e);
      } finally {
        window.clearTimeout(fallback);
        hideLegacyPreloader();
      }
    })();
  }, []);
}

